import { Routes } from '@angular/router';

import { InventoryCategoriesComponent } from './inventory-categories/inventory-categories.component';
import { InventoryItemsComponent } from './inventory-items/inventory-items.component';
import { InventoryLocationsComponent } from './inventory-locations/inventory-locations.component';
import { InventoryComponent } from './inventory/inventory.component';

export enum InventoryRoutes {
	ITEMS = 'items',
	CATEGORIES = 'categories',
	LOCATIONS = 'locations',
}

export const inventoryRoutes: Routes = [
	{
		path: '',
		component: InventoryComponent,
		title: 'ServeOx | Inventory',
		children: [
			{
				path: '',
				redirectTo: InventoryRoutes.ITEMS,
				pathMatch: 'full',
			},
			{
				path: InventoryRoutes.ITEMS,
				component: InventoryItemsComponent,
			},
			{
				path: InventoryRoutes.CATEGORIES,
				component: InventoryCategoriesComponent,
			},
			{
				path: InventoryRoutes.LOCATIONS,
				component: InventoryLocationsComponent,
			},
			{
				path: '**',
				redirectTo: InventoryRoutes.ITEMS,
			},
		],
	},
	{
		path: '**',
		redirectTo: '',
	},
];
